import React from "react";
import { connect } from "react-redux";

import Slider from "../../components/Slider";
import Graph from "../../components/graphs/ZoomedGraph";
import GraphOptions from "./GraphOptions";
import {
  Main,
  GraphDetailContainer,
  SliderContainer,
  RightArrowIconSt,
  LeftArrowIconSt,
  ZoomedMainArea as MainArea,
  ZoomedGraphContainer as GraphContainer
} from "../../components/StyledComponents";

const ChannelZoomed = props => {
  const { theme, data } = props;
  return (
    <>
      <GraphOptions />
      <Main>
        <GraphDetailContainer>
          <MainArea>
            <GraphContainer>
              <LeftArrowIconSt />
              <Graph
                data={data}
                color="#E26B05"
                gradient={
                  theme === "dark"
                    ? ["#041A2F", "#E26B05"]
                    : ["#E8DBDB", "#E26B05"]
                }
              />
              <RightArrowIconSt />
            </GraphContainer>

            <SliderContainer>
              <Slider theme={theme} />
            </SliderContainer>
          </MainArea>
        </GraphDetailContainer>
      </Main>
    </>
  );
};

const mapStateToProps = state => ({
  theme: state.themes.theme,
  data: state.channelZoomed.data
});

export default connect(
  mapStateToProps,
  null
)(ChannelZoomed);
